import * as React from 'react';
import { CountryData } from '../types';
import { Subheading } from 'components/src/typography';
import PriceListItem from './PriceListItem';
import { motion } from 'framer-motion';

type Props = {
  countryData: CountryData;
};

const CallToAbroadData = ({ countryData }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      className="col-span-full flex flex-col md:col-span-6 md:col-start-2"
    >
      <Subheading small bold classes="mb-16 text-black-100">
        {'Verðskrá'}
      </Subheading>
      <PriceListItem title="Hringt í farsíma (upphafsgjald)" price={countryData.startForeignGSM} />
      <PriceListItem title="Hringt í farsíma (mínútugjald)" price={countryData.minForeignGSM} />
      <PriceListItem title="SMS" price={countryData.smsForeignGSM} />
      <PriceListItem title="Hringt í heimasíma (upphafsgjald)" price={countryData.startForeignHomePhone} />
      <PriceListItem title="Hringt í heimasíma (mínútugjald)" price={countryData.minForeignHomePhone} />
    </motion.div>
  );
};
export default CallToAbroadData;
